import React from 'react';
import {TextField} from '@mui/material'
import {fonts} from '../../util/Theme'

/**
 * TextField formatted using the fontsize configured in Theme.js
 * @component
 * @category Stylized Components 
 */
function FormattedTextField(props) {
    return (
        <TextField {...props} InputLabelProps={{ sx: { fontSize: fonts.labelSize} }}>
            {props.children}
        </TextField>
    );
}



export default FormattedTextField;